export enum WorkQueueColors {
    Cream = "#f4f1de",
    Green = "#90be6d",
    Yellow = "#f9c74f",
    Orange = "#f3722c",
    Blue = "#457b9d",
    BlueGreen = "#43aa8b",
    Salmon = "#e07a5f",
    Red = "#f94144",
    Grey = "#5f797b"
}